import InterfaceResep from "@/apiInterface/InterfaceResep";
import ErrorAlert from "@/utility/ErrorAlert";

class DataResepFarmasi {
  async getDataListTransaksi(reg) {
    let dt: any;
    await InterfaceResep.getAllTransaksiResep(reg)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "List Transaksi Farmasi");
      });
    return dt;
  }
  async getDataPerTransaksi(no_trans, tgl) {
    let dt: any;
    await InterfaceResep.getTransaksiResep(no_trans, tgl)
      .then(response => {
        dt = response.data;
        // console.log(dt);
      })
      .catch(e => {
        console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "List Transaksi Farmasi");
      });
    return dt;
  }
}

export default new DataResepFarmasi();
